import { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { TextInput, Select } from '@octano/global-ui';
import { useValidations } from '../../../../../hooks/useValidations';

import { CourseFormContext } from '../../providers/CourseProvider';
import { SectionTitle } from '../../../../../components/text';
import { CourseFormFields } from '../../types';
import { TranslationsKeys } from '../../../../../locales/translations';
import { formatToOnlyPositiveIntegers } from '../../../../../utils/currency';

const CourseDetailsSection = () => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);
  const { msgValidations, rulesPatternNumeric } = useValidations();

  const { control } = useFormContext<CourseFormFields>();

  const { isDisabledToUpdate, formData } = useContext(CourseFormContext);
  const {
    schools = [],
    academicLevels = [],
    modalities = [],
    replaceCourseGradeOptions = [],
    coursesFeatures,
  } = formData;

  return (
    <Row>
      <Col xs={12} className="pt-4 pb-3">
        <SectionTitle text={t(`dataCourse`)} />
      </Col>
      <Col xs={6} lg={4}>
        <TextInput
          name="shortening"
          label={t(`shortening`)}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={6} lg={4}>
        <TextInput
          name="code"
          label={t(`code`)}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="name"
          label={t(`name`)}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={12} lg={4}>
        <Select
          name="school"
          label={t(`school`)}
          options={schools}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={12} lg={4}>
        <Select
          name="modality"
          label={t(`modality`)}
          options={modalities}
          control={control}
          isClearable={true}
        />
      </Col>
      <Col xs={12} lg={4}>
        <Select
          name="academicLevel"
          label={t(`academicLevel`)}
          options={academicLevels}
          control={control}
          rules={{ required: msgValidations.required }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="credits"
          label={t(`credits`)}
          control={control}
          rules={{
            required: msgValidations.required,
            pattern: rulesPatternNumeric,
          }}
          disabled={isDisabledToUpdate}
        />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="totalHours"
          label={t('totalHours')}
          control={control}
          rules={{
            pattern: rulesPatternNumeric,
          }}
          formatter={formatToOnlyPositiveIntegers}
        />
      </Col>
      {!!coursesFeatures?.replaceCourseGradeAllowed && (
        <Col xs={12} lg={4}>
          <Select
            name="replaceCourseGradeAllowed"
            label={t(`replaceCourseGradeAllowed`)}
            options={replaceCourseGradeOptions}
            control={control}
          />
        </Col>
      )}
      {!!coursesFeatures?.replaceEvaluationGradeAllowed && (
        <Col xs={12} lg={4}>
          <Select
            name="replaceEvaluationGradeAllowed"
            label={t(`replaceEvaluationGradeAllowed`)}
            control={control}
            options={replaceCourseGradeOptions}
          />
        </Col>
      )}
    </Row>
  );
};

export default CourseDetailsSection;
